var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprovalsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Sharedata"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9807 10.5829C16.324 9.62569 17.2 8.05515 17.2 6.28C17.2 3.36394 14.8361 1 11.92 1C9.00394 1 6.64 3.36394 6.64 6.28C6.64 8.13348 7.59502 9.76389 9.03983 10.706C9.18258 11.5517 9.37419 12.4648 9.57279 13.4H7.19999C5.43268 13.4 4 14.8327 4 16.6L4.00001 18.2C4 19.0836 4.71635 19.8 5.6 19.8L5.6 21C5.6 22.1045 6.49543 23 7.59999 23L16.4 23C17.5045 22.9999 18.3999 22.1045 18.4 21L18.3999 19.7999C19.2837 19.8 20 19.0837 19.9999 18.2L20 16.5999C20 14.8327 18.5673 13.4 16.8 13.3999L14.4272 13.4C14.6355 12.4192 14.8361 11.4628 14.9807 10.5829ZM15.66 6.28C15.66 8.34554 13.9855 10.02 11.92 10.02C9.85446 10.02 8.18 8.34554 8.18 6.28C8.18 4.21445 9.85446 2.54 11.92 2.54C13.9855 2.54 15.66 4.21445 15.66 6.28ZM13.2052 11.4025C12.7938 11.5054 12.3633 11.56 11.92 11.56C11.5366 11.56 11.1627 11.5191 10.8024 11.4415C10.9159 12.0177 11.0463 12.6329 11.1837 13.2816L11.2087 13.4L12.7912 13.4L12.8162 13.2821C12.9568 12.6186 13.0899 11.99 13.2052 11.4025ZM16.7999 15C17.6836 14.9999 18.4 15.7163 18.3999 16.6L18.3999 18.1999L5.6 18.2L5.6 16.6C5.6 15.7164 6.31635 15 7.19999 15L16.7999 15ZM7.19999 19.8L16.7999 19.7999L16.8 21C16.8 21.2209 16.6209 21.4 16.4 21.4L7.6 21.4C7.37909 21.4 7.19999 21.2209 7.19999 21L7.19999 19.8Z",
    fill: "#29313D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalsIcon);
export default __webpack_public_path__ + "static/media/approvals-icon.a9d4b95c843c7c5a932623fafecfbbbe.svg";
export { ForwardRef as ReactComponent };